import { Body, Box, Icon, Sheet, VStack } from '@hover/blueprint';
import { iTrash2 } from '@hover/icons';
import React, { useState } from 'react';

import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { useActiveOriginalImage, useHomeownerAppContext } from '../../hooks';
import { isAiOriginal } from '../../types';
import { MenuLinkDivider } from '../MenuLink';

import { DeleteConfirmation } from './DeleteConfirmation';

const MoreActions = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  const [step, setStep] = useState('more-actions');

  const { trackingData } = useHomeownerAppContext();
  const { image } = useActiveOriginalImage();

  const options = [
    {
      title: t('uploadedImage.delete.delete'),
      onClick: () => {
        setStep('delete-confirmation');
      },
      optionalTrackingProperties: {
        ...trackingData,
        button_location: 'original-image-more-actions-menu',
        track_id: 'delete-original-image',
        ai_original_image_id: isAiOriginal(image) ? image.id : undefined,
      },
      icon: iTrash2,
    },
  ];

  return step === 'more-actions' ? (
    <Sheet.Contents contentKey="more-actions">
      <VStack paddingY={400} width="100%">
        {options.map(
          ({ title, onClick, optionalTrackingProperties, icon }, index) => (
            <Box key={title} width="100%">
              <Button
                display={{ base: 'none', tablet: 'block' }}
                key={`desktop-${title}`}
                onClick={onClick}
                optionalTrackingProperties={optionalTrackingProperties}
                variant="primary"
                width="100%"
              >
                {title}
              </Button>
              <Box
                display={{ base: 'flex', tablet: 'none' }}
                flexDirection="column"
                width="100%"
              >
                {index !== 0 && <MenuLinkDivider key={`divider-${title}`} />}
                <Box
                  alignItems="center"
                  justifyContent="space-between"
                  key={`mobile-${title}`}
                  onClick={onClick}
                  width="100%"
                >
                  <Body fontWeight={700} size={500}>
                    {title}
                  </Body>
                  <Icon icon={icon} />
                </Box>
              </Box>
            </Box>
          ),
        )}
      </VStack>
    </Sheet.Contents>
  ) : (
    <DeleteConfirmation
      onClose={() => {
        setStep('more-actions');
      }}
    />
  );
};

export { MoreActions };
